import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetofivejyotilingadarshan() {



  const cardData = {




keyword: "Pune to 5 Jyotirlinga Darshan Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to 5 Jyotirlinga Darshan Cab Service for devotees and families planning a spiritual pilgrimage across Maharashtra. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for multi-day religious journeys with flexible itineraries. Our experienced drivers, clean vehicles, spacious luggage facilities, transparent pricing, doorstep pickup, and 24/7 customer assistance help make long-distance temple travel convenient and peaceful. Whether you are traveling with family, senior citizens, or a group of devotees, Garud Cab Service can arrange a comfortable cab for a customized Jyotirlinga Darshan route.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga Nashik",
    description: "Trimbakeshwar Jyotirlinga Temple is one of the twelve revered Jyotirlingas of Lord Shiva and is situated near the Brahmagiri hills in Nashik district. The temple is known for its distinctive architecture, spiritual importance, and association with the origin of the Godavari River. Devotees traveling from Pune can include Trimbakeshwar as an important stop on their multi-temple pilgrimage itinerary."
  },
  {
    title: "Bhimashankar Jyotirlinga Pune",
    description: "Bhimashankar Temple is a revered Jyotirlinga situated in the Sahyadri ranges of Maharashtra and is surrounded by dense forests and scenic mountain landscapes. The temple attracts devotees throughout the year and offers a peaceful spiritual environment. Its location makes it an important pilgrimage destination for travelers beginning a five-Jyotirlinga journey from Pune."
  },
  {
    title: "Grishneshwar Jyotirlinga Ellora",
    description: "Grishneshwar Jyotirlinga Temple near Ellora is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva. The temple features traditional stone architecture and has strong religious and historical significance. Devotees can combine their temple visit with nearby Ellora Caves and other heritage attractions while traveling through the Aurangabad region."
  },
  {
    title: "Aundha Nagnath Temple Hingoli",
    description: "Aundha Nagnath Temple in Maharashtra is an important Shaivite pilgrimage destination traditionally associated with the Jyotirlinga tradition. The ancient temple attracts devotees seeking blessings and spiritual experiences. A private pilgrimage cab provides convenient transportation for families and groups traveling from Pune to this important religious location."
  },
  {
    title: "Parli Vaijnath Temple Beed",
    description: "Parli Vaijnath Temple is a highly revered Lord Shiva temple located in Maharashtra and is traditionally counted among the Jyotirlinga pilgrimage destinations. The temple attracts devotees from different parts of India throughout the year. Travelers can visit the shrine comfortably with a dedicated cab while following a customized multi-day religious route."
  },
  {
    title: "Ellora Caves Aurangabad",
    description: "Ellora Caves are a UNESCO World Heritage Site located close to Grishneshwar and feature remarkable rock-cut Buddhist, Hindu, and Jain monuments. The Kailasa Temple is one of the most impressive structures at the site. Pilgrims traveling for Jyotirlinga Darshan can include Ellora sightseeing in their itinerary for a combination of spiritual and historical exploration."
  },
  {
    title: "Shirdi Sai Baba Temple",
    description: "Shirdi is one of Maharashtra's most visited pilgrimage destinations and is home to the revered Sai Baba Temple. Devotees can visit the Samadhi Mandir, Dwarkamai, Chavadi, and other associated spiritual locations. Shirdi can be added as an additional religious stop during an extended Maharashtra temple tour from Pune."
  },
  {
    title: "Shani Shingnapur Temple",
    description: "Shani Shingnapur is a well-known religious village in Maharashtra dedicated to Lord Shani and is famous for its unique open-air shrine. Devotees visit the temple throughout the year as part of their pilgrimage journeys. Its location makes it a convenient additional spiritual stop when planning a longer temple circuit by private cab."
  },
  {
    title: "Parvati Hill Pune",
    description: "Parvati Hill is a historic spiritual landmark in Pune featuring ancient temples dedicated to several Hindu deities and offering panoramic views of the city. It can serve as a convenient starting or concluding religious stop for travelers beginning a Jyotirlinga pilgrimage from Pune. The hill also provides an opportunity to experience Pune's cultural and religious heritage."
  },
  {
    title: "Ghrishneshwar and Verul Heritage Route",
    description: "The Verul region around Grishneshwar offers a combination of religious and historical attractions, making it valuable for pilgrims planning a detailed Maharashtra tour. Along with the Jyotirlinga temple, travelers can explore nearby heritage sites and scenic surroundings. A private Garud Cab Service vehicle allows devotees to organize temple visits, sightseeing breaks, and overnight travel according to their schedule."
  }
],


"services": [
{
"name": "Pune to 5 Jyotirlinga Darshan Cab",
"description": "Book Pune to 5 Jyotirlinga Darshan Cab for a comfortable and well-planned pilgrimage journey across Maharashtra with experienced chauffeurs, clean AC vehicles, flexible travel schedules, and convenient doorstep pickup. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and luxury vehicles for family groups, senior citizens, and multi-day spiritual tours."
},
{
"name": "Pune to Panch Jyotirlinga Cab Service",
"description": "Choose Pune to Panch Jyotirlinga Cab Service for dependable multi-destination temple travel with professional drivers, comfortable vehicles, flexible itineraries, and convenient pickup and drop facilities. The service is suitable for families, devotees, senior citizens, and groups planning a peaceful Panch Jyotirlinga pilgrimage from Pune."
},
{
"name": "Pune to 5 Jyotirlinga Taxi Booking",
"description": "Book Pune to 5 Jyotirlinga Taxi Booking for a convenient pilgrimage experience with experienced chauffeurs, spacious AC cars, planned temple visits, and flexible journey schedules. Select a vehicle according to your group size and enjoy comfortable transportation throughout the multi-day Jyotirlinga darshan."
},
{
"name": "Pune to 5 Jyotirlinga Cab Package",
"description": "Reserve a Pune to 5 Jyotirlinga Cab Package for organized temple travel covering multiple sacred destinations with private chauffeur-driven transportation. Packages can be arranged for families and groups with suitable vehicles, flexible sightseeing plans, comfortable overnight travel, and convenient pickup from your preferred location in Pune."
},
{
"name": "Pune to Panch Jyotirlinga Taxi Service",
"description": "Pune to Panch Jyotirlinga Taxi Service provides comfortable private transportation for devotees visiting multiple Jyotirlinga temples. Travel in clean AC vehicles with trained chauffeurs, spacious seating, luggage room, flexible halt options, and customized schedules designed around your pilgrimage requirements."
},
{
"name": "Pune to 5 Jyotirlinga Darshan Taxi",
"description": "Book Pune to 5 Jyotirlinga Darshan Taxi for a smooth spiritual road journey with private transportation, professional chauffeurs, comfortable seating, and flexible temple visit schedules. It is a practical choice for families, elderly travelers, and groups looking for convenient travel between important pilgrimage destinations."
},
{
"name": "Pune to Panch Jyotirlinga Cab Rental",
"description": "Hire Pune to Panch Jyotirlinga Cab Rental for a private multi-day pilgrimage with reliable vehicles and experienced drivers. Enjoy convenient pickup, spacious interiors, AC comfort, luggage capacity, and flexible routing for visiting several Jyotirlinga temples without depending on public transportation."
},
{
"name": "Pune to 5 Jyotirlinga Cab Fare",
"description": "Check Pune to 5 Jyotirlinga Cab Fare according to your selected vehicle, travel duration, route, and trip requirements. Get a suitable chauffeur-driven option for long-distance temple travel with comfortable AC cars, transparent trip planning, flexible schedules, and convenient pickup and drop arrangements."
},
{
"name": "Pune to 5 Jyotirlinga Cab Price",
"description": "Get Pune to 5 Jyotirlinga Cab Price details based on vehicle category, number of travel days, route coverage, and group size. Choose from economical sedans, spacious SUVs, Innova, Innova Crysta, Kia Carens, and larger vehicles for a comfortable pilgrimage journey with professional driver support."
},
{
"name": "Pune to 5 Jyotirlinga Outstation Taxi",
"description": "Book Pune to 5 Jyotirlinga Outstation Taxi for a dedicated intercity pilgrimage journey with experienced chauffeurs and comfortable AC vehicles. The service can accommodate multi-day temple tours, family travel, senior citizen journeys, group requirements, overnight stays, and customized routes covering major Jyotirlinga destinations."
},
{
"name": "Pune to 5 Jyotirlinga Cab Booking Online",
"description": "Make Pune to 5 Jyotirlinga Cab Booking Online for convenient travel planning before your pilgrimage begins. Select your preferred vehicle, pickup location, travel dates, and trip duration while arranging a private chauffeur-driven cab suitable for families, devotees, senior citizens, and groups."
},
{
"name": "Pune to Panch Jyotirlinga Cab Package from Pune",
"description": "Choose a Pune to Panch Jyotirlinga Cab Package from Pune for a customized pilgrimage covering multiple sacred temples in one planned journey. Enjoy private transportation, experienced drivers, comfortable AC vehicles, flexible stopovers, luggage space, and travel schedules designed according to your darshan and sightseeing requirements."
},
{
"name": "Pune to Panch Jyotirlinga Taxi Fare Per Km",
"description": "Compare Pune to Panch Jyotirlinga Taxi Fare Per Km according to vehicle type, total distance, trip duration, and selected travel plan. Chauffeur-driven options are available for families and groups seeking comfortable long-distance transportation with suitable cars, spacious seating, and flexible pilgrimage itineraries."
},
{
"name": "Best Pune to 5 Jyotirlinga Cab Service",
"description": "Choose the Best Pune to 5 Jyotirlinga Cab Service for dependable pilgrimage transportation with experienced chauffeurs, clean AC vehicles, comfortable interiors, and flexible multi-day travel plans. Vehicle choices can include Sedan, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and larger group transportation options."
},
{
"name": "Affordable Pune to Panch Jyotirlinga Cab",
"description": "Book an Affordable Pune to Panch Jyotirlinga Cab for economical and comfortable temple travel without compromising on convenient transportation. Select a vehicle according to your group size and enjoy professional driver assistance, spacious luggage capacity, AC comfort, flexible stops, and customized routes for your pilgrimage."
},
{
"name": "Pune to Panch Jyotirlinga Car Rental",
"description": "Hire Pune to Panch Jyotirlinga Car Rental for a private road trip covering important Jyotirlinga temples with an experienced chauffeur. Choose from comfortable sedans, MUVs, SUVs, Innova, Innova Crysta, and premium vehicles for family pilgrimages, group tours, senior citizen travel, and multi-day journeys."
},
{
"name": "Pune to 5 Jyotirlinga Taxi Tour",
"description": "Plan a Pune to 5 Jyotirlinga Taxi Tour for a multi-day spiritual road trip with flexible schedules and private chauffeur-driven transportation. The journey can be organized according to temple timings, darshan preferences, sightseeing requirements, overnight stays, family needs, and group size."
},
{
"name": "Pune to Panch Jyotirlinga Pilgrimage Cab",
"description": "Reserve Pune to Panch Jyotirlinga Pilgrimage Cab for comfortable temple-to-temple transportation throughout your spiritual journey. Experienced chauffeurs, clean AC vehicles, spacious seating, luggage storage, and flexible travel plans make the service suitable for families, senior citizens, devotees, and organized pilgrimage groups."
},
{
"name": "Pune to Panch Jyotirlinga Itinerary Taxi",
"description": "Book Pune to Panch Jyotirlinga Itinerary Taxi for a customized pilgrimage route planned around your preferred temples, travel dates, and number of days. Enjoy private transportation with experienced drivers, flexible halt points, comfortable vehicles, and convenient travel arrangements for an organized Jyotirlinga darshan."
},
{
"name": "Cheap Pune to 5 Jyotirlinga Cabs",
"description": "Choose Cheap Pune to 5 Jyotirlinga Cabs for budget-conscious devotees seeking reliable transportation for a multi-day temple journey. Affordable vehicle categories can be selected according to group size while providing AC comfort, professional chauffeurs, luggage space, convenient pickup, and flexible travel schedules."
},
{
"name": "Luxury Pune to Panch Jyotirlinga Cab",
"description": "Travel in comfort with a Luxury Pune to Panch Jyotirlinga Cab featuring premium interiors, spacious seating, AC comfort, experienced chauffeurs, and personalized travel arrangements. It is ideal for families and groups looking for a more relaxed pilgrimage experience with flexible routes and convenient temple visits."
},
{
"name": "Pune to 5 Jyotirlinga Taxi Deals",
"description": "Explore Pune to 5 Jyotirlinga Taxi Deals for suitable private cab options based on vehicle category, travel duration, route, and group size. Plan your pilgrimage with comfortable chauffeur-driven transportation, flexible schedules, spacious luggage capacity, and vehicle choices ranging from sedans to premium SUVs."
},
{
"name": "Pune to Panch Jyotirlinga Darshan Package",
"description": "Book a Pune to Panch Jyotirlinga Darshan Package for an organized spiritual journey with private cab transportation and flexible temple visit schedules. The package can be customized for families, senior citizens, couples, and groups with suitable vehicles, professional drivers, comfortable travel, and convenient pickup and drop."
},
{
"name": "Pune to Bhimashankar Cab",
"description": "Hire Pune to Bhimashankar Cab for a comfortable pilgrimage to the sacred Bhimashankar Jyotirlinga with experienced chauffeurs and well-maintained AC vehicles. Choose a sedan, Ertiga, Innova, Innova Crysta, or SUV according to your group size and enjoy flexible pickup, temple travel, sightseeing, and return options."
},
{
"name": "Pune to Trimbakeshwar Cab",
"description": "Book Pune to Trimbakeshwar Cab for convenient travel to the famous Trimbakeshwar Jyotirlinga near Nashik. Enjoy private chauffeur-driven transportation, comfortable AC vehicles, spacious luggage room, flexible departure timings, and customized pilgrimage plans for families, devotees, and senior citizens."
},
{
"name": "Pune to Grishneshwar Cabs",
"description": "Reserve Pune to Grishneshwar Cabs for a smooth pilgrimage to Grishneshwar Jyotirlinga with reliable private transportation. Select from comfortable sedans, MUVs, SUVs, Innova, Innova Crysta, and other suitable vehicles while enjoying experienced chauffeurs, flexible travel schedules, and convenient temple-to-temple journeys."
},
{
"name": "Pune to Aundha Nagnath Cab",
"description": "Choose Pune to Aundha Nagnath Cab for comfortable long-distance travel to the revered Aundha Nagnath temple. The service offers private chauffeur-driven transportation, clean AC vehicles, spacious seating, luggage capacity, flexible stopovers, and convenient travel arrangements for families and pilgrimage groups."
},
{
"name": "Pune to Parli Vaijnath Cab",
"description": "Book Pune to Parli Vaijnath Cab for a peaceful and convenient pilgrimage journey to the sacred Parli Vaijnath temple. Travel with experienced chauffeurs in comfortable AC vehicles with flexible schedules, convenient pickup and drop facilities, spacious interiors, and vehicle choices suitable for families and groups."
},
{
"name": "Panch Jyotirlinga Tour Package from Pune",
"description": "Plan a Panch Jyotirlinga Tour Package from Pune with private chauffeur-driven transportation covering major Jyotirlinga destinations in a customized multi-day itinerary. Choose a suitable Sedan, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, or larger group vehicle for comfortable family and group pilgrimage travel."
},
{
"name": "Pune Bhimashankar Trimbakeshwar Grishneshwar Cab",
"description": "Book Pune Bhimashankar Trimbakeshwar Grishneshwar Cab for a dedicated pilgrimage route connecting three important Jyotirlinga temples. Enjoy private AC transportation, experienced chauffeurs, flexible sightseeing stops, luggage space, and customized travel schedules suitable for families, devotees, and senior citizens."
},
{
"name": "Pune to Bhimashankar and Trimbakeshwar Tour",
"description": "Choose Pune to Bhimashankar and Trimbakeshwar Tour for a convenient spiritual road journey covering two significant Jyotirlinga destinations. Travel in a private chauffeur-driven vehicle with comfortable seating, flexible departure times, sightseeing opportunities, luggage space, and customized return arrangements."
},
{
"name": "Bhimashankar Trimbakeshwar Grishneshwar Tour from Pune",
"description": "Plan a Bhimashankar Trimbakeshwar Grishneshwar Tour from Pune with private cab transportation designed for multi-temple pilgrimage travel. Enjoy experienced drivers, clean AC vehicles, flexible stopovers, spacious interiors, and a customized itinerary that allows families and groups to travel comfortably between the temples."
},
{
"name": "Pune to Aundha Nagnath Cab",
"description": "Reserve Pune to Aundha Nagnath Cab for dependable intercity transportation to one of Maharashtra's important Jyotirlinga pilgrimage destinations. Comfortable AC vehicles, professional chauffeurs, flexible schedules, spacious luggage capacity, and private pickup options make the journey convenient for devotees and families."
},
{
"name": "Pune to Parli Vaijnath Cab",
"description": "Hire Pune to Parli Vaijnath Cab for a comfortable pilgrimage journey with private chauffeur-driven transportation from Pune to Parli. Select a vehicle based on your group size and enjoy AC comfort, experienced driver support, flexible travel timings, luggage space, and convenient pickup and drop arrangements."
}
],
"tableData": [
["Pune to 5 Jyotirlinga Darshan Cab", "Pune to Panch Jyotirlinga Cab Service"],
["Pune to 5 Jyotirlinga Taxi Booking", "Pune to 5 Jyotirlinga Cab Package"],
["Pune to Panch Jyotirlinga Taxi Service", "Pune to 5 Jyotirlinga Darshan Taxi"],
["Pune to Panch Jyotirlinga Cab Rental", "Pune to 5 Jyotirlinga Cab Fare"],
["Pune to 5 Jyotirlinga Cab Price", "Pune to 5 Jyotirlinga Outstation Taxi"],
["Pune to 5 Jyotirlinga Cab Booking Online", "Pune to Panch Jyotirlinga Cab Package from Pune"],
["Pune to Panch Jyotirlinga Taxi Fare Per Km", "Best Pune to 5 Jyotirlinga Cab Service"],
["Affordable Pune to Panch Jyotirlinga Cab", "Pune to Panch Jyotirlinga Car Rental"],
["Pune to 5 Jyotirlinga Taxi Tour", "Pune to Panch Jyotirlinga Pilgrimage Cab"],
["Pune to Panch Jyotirlinga Itinerary Taxi", "Cheap Pune to 5 Jyotirlinga Cabs"],
["Luxury Pune to Panch Jyotirlinga Cab", "Pune to 5 Jyotirlinga Taxi Deals"],
["Pune to Panch Jyotirlinga Darshan Package", "Pune to Bhimashankar Cab"],
["Pune to Trimbakeshwar Cab", "Pune to Grishneshwar Cabs"],
["Pune to Aundha Nagnath Cab", "Pune to Parli Vaijnath Cab"],
["Panch Jyotirlinga Tour Package from Pune", "Pune Bhimashankar Trimbakeshwar Grishneshwar Cab"],
["Pune to Bhimashankar and Trimbakeshwar Tour", "Bhimashankar Trimbakeshwar Grishneshwar Tour from Pune"],
["Pune to Aundha Nagnath Cab", "Pune to Parli Vaijnath Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to 5 Jyotirlinga Darshan Cab",
    WhyChoosedescription: "Garud Cab Service provides dedicated cab arrangements for devotees planning a multi-destination 5 Jyotirlinga Darshan journey from Pune, offering a practical travel option for families, senior citizens, and groups."
  },
  {
    WhyChooseheading: "Planned Multi-Temple Pilgrimage Travel",
    WhyChoosedescription: "A 5 Jyotirlinga pilgrimage involves covering several temple destinations, so a private cab allows travellers to organize their route, stay periods, temple visits, and return journey according to their preferred itinerary."
  },
  {
    WhyChooseheading: "Comfortable Option for Family Darshan",
    WhyChoosedescription: "Families travelling together can enjoy the convenience of a dedicated vehicle with suitable seating and luggage space, making long-distance temple travel more manageable throughout the pilgrimage."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Trip Arrangement",
    WhyChoosedescription: "Plan your pilgrimage over multiple days instead of following a fixed public transport schedule. The trip can be organized around temple timings, accommodation plans, sightseeing, and required rest breaks."
  },
  {
    WhyChooseheading: "Suitable Vehicles for Devotees & Groups",
    WhyChoosedescription: "Garud Cab Service can arrange suitable cars or larger travel options depending on the number of devotees, luggage, and overall journey requirements for the 5 Jyotirlinga Darshan."
  },
  {
    WhyChooseheading: "Convenient Pune Pickup",
    WhyChoosedescription: "Begin the pilgrimage from your preferred Pune location, such as your home, hotel, residential area, or another convenient pickup point, and travel directly towards the planned temple circuit."
  },
  {
    WhyChooseheading: "Useful for Senior Citizens & Extended Families",
    WhyChoosedescription: "Private transportation can provide greater convenience for senior family members and extended groups by allowing planned breaks, comfortable travel, and a journey schedule suited to the family's requirements."
  },
  {
    WhyChooseheading: "Organize Your Jyotirlinga Journey with Garud",
    WhyChoosedescription: "Share your preferred travel dates, number of devotees, pickup location, vehicle requirement, and planned pilgrimage itinerary with Garud Cab Service to arrange suitable transportation for your 5 Jyotirlinga Darshan."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to 5 Jyotirlinga Darshan Cab Service?",
    answer: "Yes, Garud Cab Service provides cab arrangements from Pune for devotees planning a 5 Jyotirlinga Darshan pilgrimage."
  },
  {
    question: "Can I book a cab for a multi-day Jyotirlinga pilgrimage?",
    answer: "Yes, a multi-day private cab arrangement can be planned according to your temple itinerary, travel dates, accommodation schedule, and return requirements."
  },
  {
    question: "Is this service suitable for family pilgrimage trips?",
    answer: "Yes, the service is suitable for families, senior citizens, couples, groups of devotees, and extended family members travelling together."
  },
  {
    question: "Can I choose the vehicle according to my group size?",
    answer: "Yes, vehicle selection can be discussed according to the number of passengers, luggage, comfort requirements, and overall pilgrimage plan."
  },
  {
    question: "Can senior citizens travel comfortably on the Jyotirlinga trip?",
    answer: "Yes, a private cab can provide a more convenient travel arrangement for senior citizens by allowing planned breaks and a flexible journey schedule."
  },
  {
    question: "Can I customize the 5 Jyotirlinga Darshan itinerary?",
    answer: "Yes, you can discuss your preferred temple sequence, travel dates, stay requirements, sightseeing plans, and return schedule while arranging the cab."
  },
  {
    question: "Can pickup be arranged from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, residential area, office, or another preferred location in Pune."
  },
  {
    question: "How many days are required for a 5 Jyotirlinga trip?",
    answer: "The required duration depends on the selected temples, route, sightseeing, rest periods, accommodation plan, and individual travel preferences."
  },
  {
    question: "Can I include other religious places during the journey?",
    answer: "Yes, additional religious or sightseeing destinations can be discussed while planning the itinerary, depending on the available time and route."
  },
  {
    question: "How can I book a Pune to 5 Jyotirlinga Darshan Cab?",
    answer: "Share your travel dates, Pune pickup location, number of devotees, preferred vehicle, temple itinerary, and approximate trip duration with Garud Cab Service to plan the booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Mahendra Patil",
    feedback: "Our family planned a Jyotirlinga pilgrimage from Pune and needed a private vehicle for the entire journey. Garud Cab Service helped us arrange comfortable transportation for the group.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Joshi",
    feedback: "We travelled with senior family members for our temple darshan trip. Having a dedicated cab made it easier to manage our travel schedule, luggage, and rest breaks during the journey.",
    rating: 5
  }
];















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to 5 Jyotirlinga Darshan Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-5-jyotirlinga-cab-service.webp",
  "description": "Plan a comfortable Pune to 5 Jyotirlinga Darshan Cab journey with Garud Cab for a convenient pilgrimage experience. Get reliable cab and taxi services for Panch Jyotirlinga tours from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options, suitable for families, senior citizens, and groups seeking a well-planned religious tour.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-5-jyotirlinga-cab-service"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune to 5 Jyotirlinga Darshan Cab | Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to 5 Jyotirlinga Darshan Cab with Garud Cab for a comfortable and convenient pilgrimage tour. Get reliable Panch Jyotirlinga cab service and taxi booking from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to 5 Jyotirlinga Darshan Cab, Pune to Panch Jyotirlinga cab service, Pune to 5 Jyotirlinga taxi booking, Pune to 5 Jyotirlinga cab package"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetofivejyotilingadarshan;